export default __webpack_public_path__ + "static/media/sidebar-icon-bookings.c45f6bff.svg";